<entity-icon *ngIf="model.icon" class="icon" [model]="model.icon" [size]="'12px'"></entity-icon>
<u-emoji *ngIf="model?.emojiUnicode" [spriteEmojiSize]="14" [unicode]="model.emojiUnicode"></u-emoji>
<div class="title" [class.has-icon]="!!model.icon && model.icon.type !== 'account'">
  <span *ngIf="model.type != 'page' && !EXCLUDED_TAGS.includes(model.label?.toLowerCase()) && model.label">
    {{ model.label | capitalize }}:
  </span>
  <ng-container *ngIf="!isCustomDate; else datePicker">
    {{ model.title }}
  </ng-container>
</div>

<ng-template #datePicker>
  <div class="date-picker-selected">
    <div
      *ngIf="
        !!selectedCustomValue &&
          ((selectedCustomValue.type !== 'range' && selectedCustomValue.dates[0]) ||
            (selectedCustomValue.type === 'range' && (selectedCustomValue.dates[0] || selectedCustomValue.dates[1])));
        else empty
      "
    >
      <div class="content" *ngIf="selectedCustomValue?.type !== 'range'">
        <p class="type">{{ selectedCustomValue?.type | titlecase }}:</p>
        <p class="date">{{ selectedCustomValue?.dates[0] }}</p>
      </div>
      <div class="content" *ngIf="selectedCustomValue?.type === 'range'">
        <p class="date">{{ customRange[0] ?? selectedCustomValue?.dates[0] }}</p>
        <u-icon class="arrow-icon" [model]="{ type: 'font', value: 'icon-arrow-right' }"></u-icon>
        <p class="date">{{ customRange[1] ?? selectedCustomValue?.dates[1] }}</p>
      </div>
    </div>
    <ng-template #empty>
      <div class="content">
        <div *ngIf="selectedCustomValue?.type === 'range'" class="range-type">
          <p class="type">From - To</p>
        </div>
        <div *ngIf="selectedCustomValue?.type !== 'range'" class="type-container">
          <div class="single-type">
            <p class="type">{{ selectedCustomValue?.type | titlecase }}</p>
          </div>
        </div>
        <p>(mm/dd/yyyy)</p>
      </div>
    </ng-template>
  </div>
</ng-template>

<div class="remove-button-container" *ngIf="removable">
  <times-button
    class="remove-button"
    [backgroundColor]="'transparent'"
    [color]="'var(--color-border-active)'"
    (click)="onRemove()"
  ></times-button>
</div>
